module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-lena2.8330adf0.jpeg";